import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getWayActivityAvailability } from "../../../action/wayActivities";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { popupOpenClose } from "../../../action/action";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { CalenderSvg } from "./WayActivity3";
import { DayPicker } from "react-day-picker";
import { formatTime } from "../spaBookingV2/spaBooking2a";
import { toBool } from "../../JS/utility";
import { scrollToTop } from "../../../JS/scrollToTop";

function UpdateBookingPage(props){
    const [updatedBookingDetails, setUpdatedBookingDetails] = useState({});
    const [availabilityData, setAvailabilityData]= useState(null);
    const [dateSpecificAvailabilityData, setDateSpecificAvailabilityData]= useState(null);
    const {bookingOverviewDetails, handleUpdateBooking, t} = props;
    const [renderDatePicker, setRenderDatePicker ] = useState(false);

    const fetchAvailability = async () => {
  
        props.setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.fetching_availability")});
        try {
          await getWayActivityAvailability(bookingOverviewDetails.experience.id, undefined)
          .then(data=>{
            if(!data.sessions) throw { message: t("way_activity.update_booking_page.errors.missing_sessions") };
            if(data.sessions.length==0) throw { message : t("way_activity.update_booking_page.errors.no_sessions_on_date") };
    
            setAvailabilityData(data);
          })
          .catch((errMessage)=>{
            console.log("err", JSON.stringify(errMessage))
            props.closeOrderPopUp(true,  errMessage.message, "", true);
    
            setAvailabilityData(null);

          })
          .finally(()=>{
            props.setLoaderDetails({show:false});
    
          })
         
        } catch (err) {
          console.error("...", err);
        }
    };

    const isDateDisabled = (date) => {
      console.log("date", moment(date).format("YYYY-MM-DD"))
      if( availabilityData && availabilityData.sessions && availabilityData.sessions.some(session =>{ return session.date == moment(date).format("YYYY-MM-DD")})){
        return false;
      }
      return true;
    }

    const onClickUpdateMyBooking =()=>{
        if(!updatedBookingDetails.date){
            props.popupOpenClose(true, t("way_activity.update_booking_page.validation.date_required"));
            return;
        }
        if(!updatedBookingDetails.timeSlot){
            props.popupOpenClose(true, t("way_activity.update_booking_page.validation.time_required"));
            return;
        }
        const payload = {
            "sessionTime" : updatedBookingDetails.timeSlot.startTime,
            "sessionDate": updatedBookingDetails.date,
            "sendConfirmationEmail": false,
            "bookingId" : bookingOverviewDetails.id
        }

        handleUpdateBooking(payload);
    }

    const dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;

    // useEffect(()=>{
    //     if(updatedBookingDetails.date){
    //         fetchAvailability();
    //     }
    // },[updatedBookingDetails.date])

    useEffect(()=>{
      fetchAvailability();
    },[])

    useEffect(()=>{
      scrollToTop()
    },[])

    return<>


        <section className="container">
          <div className="activity-card-container">
            <div className="activity-booking-card" style={{ color: "black" }}>
              <div className="booking">
             
              <div className="date-picker">
                    <div className="text-bold" >{t("way_activity.update_booking_page.choose_date_label")}</div>
                    {/* <input
                        type="date"
                        value={updatedBookingDetails.date || "" }
                        onChange={(e) => setUpdatedBookingDetails((prev)=>{ return { date: e.target.value}})}
                    /> */}

              <div
                          id="day-picker-input"
                         
                          onClick={()=>{setRenderDatePicker(true)}}
                        > 
                        <CalenderSvg/>
                        {updatedBookingDetails.date ? moment(updatedBookingDetails.date).format(props.dateFormat.toUpperCase()) : t("way_activity.update_booking_page.date_placeholder") }
                        </div>

              </div>


              {
                     dateSpecificAvailabilityData  && dateSpecificAvailabilityData.sessions && ( 
                     <div className="time-slots">
                        <div>
                            <div className="text-bold" >{t("way_activity.update_booking_page.time_slots_label")}</div>
                        </div>
                        <div className="time-slot-container">
                            {
                                dateSpecificAvailabilityData.sessions.length > 0 ? 
                                (
                                  dateSpecificAvailabilityData.sessions.map((session) =>{
                                        const key = session.startTime + session.endTime;

                                        return (
                                        <p
                                        key={key}
                                        className={`time-slot ${updatedBookingDetails.timeSlot && ( key === (updatedBookingDetails.timeSlot.startTime + updatedBookingDetails.timeSlot.endTime )) ? "selected" : ""}`}
                                        onClick={() => setUpdatedBookingDetails(prev => { return {...prev, timeSlot:{ startTime: session.startTime , endTime: session.endTime }}} )}
                                        >
                                        {
                                          formatTime(session.startTime,toBool(props.timeFormat)) + "-" + 
                                          formatTime(session.endTime,toBool(props.timeFormat))
                                                                     
                                        }
                                        </p>
                                    )})
                                )
                                :
                                <div> {t("way_activity.common.no_sessions")} </div> 
                            }
                        </div>
                    </div>
               )          
                    
            }
                
              </div>
          
            </div>
          </div>

          <div class="row">
              <div class="form-controls">
                <button  
                className="continue"
                onClick={onClickUpdateMyBooking} >
                    {t("way_activity.update_booking_page.update_button")}
                </button>
              </div>
            </div>
        </section>

        { renderDatePicker &&
          <div className="overlay" onClick={(event) => { setRenderDatePicker(false);}}>
          <div class="overlay-date" onClick={(event) => { event.stopPropagation();}} >
              <style>{dateInputCss}</style>
              <DayPicker
                  mode="single"
                  timeZone="UTC"
                  selected={updatedBookingDetails.date}
                  onSelect={(selectedDate) =>{ 
                    console.log(selectedDate); 
                    setRenderDatePicker(false);
                    setUpdatedBookingDetails((prev)=>{ return { date: moment(selectedDate).format("YYYY-MM-DD")}})
                    setDateSpecificAvailabilityData(()=>{
                      const dateSpecificSession = availabilityData.sessions.find(session =>{ return session.date == moment(selectedDate).format("YYYY-MM-DD")})
                      console.log(dateSpecificSession);
                      return dateSpecificSession;
                    })
                  }}
                  disabled={isDateDisabled}

              />
          </div>
        </div>
        }


    </>

}

const mapStateToProps = (state) => {
    return {
      installedAppVersion: state.store.installedAppVersion,
      installedAppBuildNo: state.store.installedAppBuildNo,
      currentHomePage: state.store2.currentHomePage,
      currentWidgetObj: state.store.sideNavBar.currentWidget,
      guestDetail: state.store.home.guestDetails,
      guestIsLoggedIn: state.store2.guestIsLoggedIn,
      currentWidgets: state.store.sideNavBar.currentWidget,
      dateFormat: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
        : "",
        timeFormat:
      state.store.home.clientConfig.extraConfigParam &&
      state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
      serverTimeDate: state.store.home.serverTimeDate.date,
      serverDate: state.store.home.serverTimeDate,
      menuColor: state.store.home.MenuColor,
    };
  };
  
  export default connect(mapStateToProps,
    {closeOrderPopUp, popupOpenClose})(
      withTranslation("translations")(UpdateBookingPage)
    );
  